import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './CommonPage/Navbar';
import Home from './Component/Home';
import Shopping from './Component/Shopping';
import Cart from './Component/Cart';
import Footer from './CommonPage/Footer';
import Contact from './Component/Contact';
import About from './Component/About';
import Checkout from './Component/Checkout';
import Thankyou from './Component/Thankyou';
import Blog from './Component/Blog';
import NewArrivals from './Component/NewArrivals';
import SpringMattress from './Component/SpringMattress';
import FoamMattress from './Component/FoamMattress';
import CoirMattress from './Component/CoirMattress';
import Polyfil from './Component/Polyfil';
import Term from './Policies/Term';
import Privacy from './Policies/Privacy';
import Refund from './Policies/Refund';
import Shipping from './Policies/Shipping';
import ProductDetails from './Component/ProductDetails';
import NewsLetter from './CommonPage/NewsLetter';
import WhatsAppButton from './CommonPage/WhatsAppButton';
import Profile from './Policies/Profile';
import BedSheet from './Component/BedSheet';

function App() {
  const location = useLocation();

  const hideLayoutPaths = [
    '/login',
    '/register',
    '/forget_password',
    '/change_password'
  ];

  const shouldHideLayout = hideLayoutPaths.includes(location.pathname);

  return (
    <>
      {!shouldHideLayout && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shopping" element={<Shopping />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/New_arrivals" element={<NewArrivals />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/spring_mattress" element={<SpringMattress />} />
        <Route path="/foam_mattress" element={<FoamMattress />} />
        <Route path="/bed_sheet" element={<BedSheet />} />
        <Route path="/coir_mattress" element={<CoirMattress />} />
        <Route path="/pillows_polyfill" element={<Polyfil />} />
        <Route path="/term_&_condition" element={<Term />} />
        <Route path="/privacy_policy" element={<Privacy />} />
        <Route path="/refund_cancellation" element={<Refund />} />
        <Route path="/shipping_policy" element={<Shipping />} />
        <Route path="/product_details" element={<ProductDetails />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>

      {!shouldHideLayout && <WhatsAppButton />}
      {!shouldHideLayout && <NewsLetter />}
      {!shouldHideLayout && <Footer />}
    </>
  );
}

export default App;
